module.exports = __webpack_public_path__ + "static/media/QuestionnaireLogo.6adc17e6.svg";